import { render, staticRenderFns } from "./InboxWidget.vue?vue&type=template&id=3953bfef&scoped=true&"
import script from "./InboxWidget.vue?vue&type=script&lang=js&"
export * from "./InboxWidget.vue?vue&type=script&lang=js&"
import style0 from "./InboxWidget.vue?vue&type=style&index=0&id=3953bfef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3953bfef",
  null
  
)

export default component.exports